import {
  CheckOutlined,
  ClearOutlined,
  Close,
  FactoryOutlined,
} from "@mui/icons-material";
import {
  Button,
  DialogContentText,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useCallback, useEffect } from "react";
import { useManufacturers } from "../../context/manufacturer-context";
import { useModal } from "../../context/modal-context";
import useInput from "../../hooks/use-input";
import { getTitleForModal } from "../../services/helpers";
import NTSModal from "../UI/NTSModal";
import NTSModalFooter from "../UI/NTSModalFooter";

const ManufacturerModal = () => {
  const { modalState, closeModal } = useModal();
  const {
    manufacturers,
    addManufacturer,
    editManufacturer,
    removeManufacturer,
  } = useManufacturers();

  const {
    value: nameValue,
    isValid: nameIsValid,
    hasError: nameHasError,
    valueChangeHandler: nameChangeHandler,
    valueBlurHandler: nameBlurHandler,
    valueResetHandler: nameResetHandler,
    setValueHandler: setNameHandler,
  } = useInput((value) => value.trim().length > 3);

  const resetForm = useCallback(() => {
    nameResetHandler();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    resetForm();
    if (
      !modalState.type ||
      modalState.type === "add" ||
      modalState.model !== "manufacturer"
    )
      return;

    const manufacturer = manufacturers.find(
      (manufacturer) => manufacturer.id === modalState.id
    );
    setNameHandler(manufacturer?.show_name);
    // eslint-disable-next-line
  }, [modalState]);

  const submitHandler = (event) => {
    event.preventDefault();
    closeModal();
    if (modalState.type === "add") {
      addManufacturer({ show_name: nameValue });
    }
    if (modalState.type === "edit") {
      editManufacturer(modalState.id, { show_name: nameValue });
    }
    if (modalState.type === "delete") {
      removeManufacturer(modalState.id);
    }
    resetForm();
  };

  let title = "";
  let buttons = (
    <>
      <Button onClick={closeModal} endIcon={<ClearOutlined />} color="error">
        Cancel
      </Button>
      <Button
        onClick={submitHandler}
        disabled={!nameIsValid}
        endIcon={<CheckOutlined />}
        color="success"
      >
        Submit
      </Button>
    </>
  );

  if (modalState.open && modalState.type) {
    title = getTitleForModal(modalState.type);
  }
  if (modalState.type === "view") {
    buttons = (
      <Button onClick={closeModal} endIcon={<Close />} color="primary">
        Close
      </Button>
    );
  }

  return (
    modalState.open &&
    modalState.model === "manufacturer" && (
      <NTSModal title={`${title} MANUFACTURER`} maxWidth="xs">
        {modalState.type === "delete" ? (
          <DialogContentText>{`Are you sure that you want to remove manufacturer ${nameValue}?`}</DialogContentText>
        ) : (
          <TextField
            margin="normal"
            required
            fullWidth
            id="name"
            label="Manufacturer"
            name="name"
            disabled={modalState.type === "view"}
            value={nameValue}
            onChange={nameChangeHandler}
            onBlur={nameBlurHandler}
            error={nameHasError}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FactoryOutlined />
                </InputAdornment>
              ),
            }}
          />
        )}
        <NTSModalFooter
          sx={{
            display: "flex",
            justifyContent: "end",
            marginY: 2,
          }}
        >
          {buttons}
        </NTSModalFooter>
      </NTSModal>
    )
  );
};

export default ManufacturerModal;
